/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */

export const SET_LIGHTSITE_SETTINGS = 'SET_LIGHTSITE_SETTINGS';
